<template>
  <v-card>
    <div class="img-wrapper">
      <slot name="logo" />
    </div>

    <div class="score-wrapper">
      <slot name="score" />
    </div>

    <div class="info-button-wrapper">
      <slot name="infoButton" />
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'LenderCardLayout',
}
</script>

<style lang="scss" scoped>
::v-deep {
  .score-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    margin: 0 auto;
    height: 100%;

    h1 {
      color: #3A3A3A;
      font-family: "Sansation Regular", sans-serif;
      font-weight: normal;
    }

    p {
      color: #0A0A0A;
      font-family: "Avenir Book", sans-serif;
    }

    @include lg {
      height: auto;

      & > * {
        margin-top: 0;
        margin-bottom: 7px;
        padding: 0;
      }
    }
  }

  .info-button-wrapper {
    width: 100%;

    .default-btn {
      box-sizing: border-box;
      padding: 0;
      width: 100%;

      color: $primaryBlue !important;
      text-align: center;

      @include lg {
        font-size: 18px;
      }
    }
  }
}

.v-card {
  display: grid;

  height: 430px;
  width: 270px;
  padding: 5px 25px 20px;

  background-color: white;
  box-shadow: $secondaryShadow;
  border-top: 40px solid $primaryBlue;

  grid-template-columns: auto;
  grid-auto-rows: 1fr auto auto;
  grid-column-gap: 25px;
  grid-row-gap: 15px;

  align-items: center;

  @include mdOnly {
    width: 250px;
  }
}
</style>
